<script setup>
import {computed, ref} from 'vue'
// обработка формы
import {useField, useForm} from "vee-validate";
// валидатор
import * as yup from "yup";
import axios from "axios";
import {useStore} from "vuex";
//----------------------------------------------------------------------------------------//

const store = useStore()

// обработка формы
const { handleSubmit, isSubmitting } = useForm();
const { value:message, errorMessage:messageError, handleBlur:messageBlur } = useField(
    'message',
    yup.string().trim().required('Содержание не должно быть пустым')
);

// загружаемый файл
const file = ref(null)
const onSubmit = handleSubmit( async (values)=> {

  try {

    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Bearer ' + token.value
    }

    //'Content-Type': 'multipart/form-data',

    let payload = {...values, ...{'section': user.value.type}, ...{'userId': user.value.id}}
    if (file.value.value !== '') {
      payload = {...payload, ...{'file': file.value.files[0]}}
    }

    //console.log(headers)
    //console.log(payload)

    const url = process.env.VUE_APP_API + "create-message.php";

    const {data} = await axios.post(url, payload, {
      headers: headers
    })

    //console.log(data)

    if (data['status'] == 'SUCCESS'){
      emit('create')
    } else {
      emit('close')
    }

  } catch (e) {
    alert ('INTERNAL_SERVER_ERROR')
  }

})
// eslint-disable-next-line no-undef,no-unused-vars
const emit = defineEmits(['close','create'])

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})

</script>

<template>
  <div class="dark-background"></div>
  <div class="modal fade show d-block">
    <div class="modal-dialog  modal-lg">
      <div class="modal-content">

        <div class="modal-header border-0">
          <h4 class="modal-title">Новое сообщение</h4>
        </div>

        <form @submit.prevent="onSubmit">
        <div class="modal-body">
          <div class="form-group">
            <textarea
                :class="['form-control', {'is-invalid': messageError}]"
                placeholder="Обязательно для заполнения"
                v-model="message"
                @blur="messageBlur"
                style="height: 220px"
            ></textarea>
            <div
                class="input-error"
                v-if="messageError"
            >{{ messageError }}</div>
          </div>

          <div class="form-group d-none">
            <label for="document">Документ</label>
            <div>
              <input
                  ref="file"
                  type="file"
                  class="form-control"
              >
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between border-0">
          <button
              type="button"
              class="btn btn-default"
              @click="$emit('close')"
          >Отмена
          </button>
          <button
              type="submit"
              class="btn btn-info fixed-width-btn"
              :disabled="isSubmitting"
          >
            <svg v-if="isSubmitting"
                 xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g>
              <circle cx="3" cy="12" r="2" fill="#fff"/>
              <circle cx="21" cy="12" r="2" fill="#fff"/>
              <circle cx="12" cy="21" r="2" fill="#fff"/>
              <circle cx="12" cy="3" r="2" fill="#fff"/>
              <circle cx="5.64" cy="5.64" r="2" fill="#fff"/>
              <circle cx="18.36" cy="18.36" r="2" fill="#fff"/>
              <circle cx="5.64" cy="18.36" r="2" fill="#fff"/>
              <circle cx="18.36" cy="5.64" r="2" fill="#fff"/>
              <animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></g>
            </svg>
            <span v-else>Сохранить</span>
          </button>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>
<style scoped>
.input-error{color:#dc3545;margin: 5px}
</style>